/**
 * Adds a currency symbol and a superscript "¹" to the original price value based on locale.
 * Converts the price to a number only to check if it's zero for bonus text, preserving the original input for display.
 *
 * @param {string|number} price - The price to display, can be a string (e.g., "258.000") or number (e.g., 258.00)
 * @param {string} locale - The locale for determining the currency symbol (e.g., "pt-br", "en-us", "es-ar")
 * @param {string} [bonusText] - Optional text to return if price is 0 (e.g., "Free")
 * @returns {string} The original price with currency symbol and "¹" appended, or bonusText if price is 0
 */
export const formatPriceAppointment = (price, locale, bonusText) => {
  const numericPrice = parseFloat(price);

  if (numericPrice === 0 && bonusText) {
    return `${bonusText}`;
  }

  const currencySymbol = getCustomCurrencySymbol(locale);

  return `${currencySymbol}${price}¹`;
};


/**
 * Retrieves a custom currency symbol based on the provided locale.
 *
 * @param {string} locale - The locale string (e.g., "pt-br", "en-us", "es-ar")
 * @returns {string} The custom currency symbol (e.g., "R$ ", "$")
 */
export const getCustomCurrencySymbol= (locale) => {
  const currencyMap = {
    'pt-br': 'R$ ',
    'en-us': '$',
    'es-ar': '$',
    'es-es': '€'
  };
  return currencyMap[locale] || '$';
};

export const getVehiclesForCustomer = async () => {
  try {
    const response = await fetch(`/api/my-vehicle/customer-vehicles`);

    if (!response.ok) {
      throw new Error(`Failed to fetch customer vehicles: ${response.status} - ${response.statusText}`);
    }

    const responseData = await response.json();

    if (responseData && Array.isArray(responseData.MyVehicle)) {
      return responseData.MyVehicle;
    } else {
      throw new Error('API response is not in the expected format.');
    }
  } catch (error) {
    console.error(`An error occurred: ${error?.message}`);
    throw error;
  }
};
